// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getOwnershipStatus} from '../../shared/repositories';

export const readOwnershipStatuses = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const statusCollection = await getOwnershipStatus();

            dispatch({
                statusCollection,
                type: actions.UPDATE_OWNERSHIP_STATUS_COLLECTION
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/ownership-status.js